import { render, staticRenderFns } from "./ScreenLaudo4d.vue?vue&type=template&id=144fc26b&lang=true&"
import script from "./ScreenLaudo4d.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudo4d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports